import { render, staticRenderFns } from "./MobileDropzone.vue?vue&type=template&id=34caad3e&"
import script from "./MobileDropzone.vue?vue&type=script&lang=js&"
export * from "./MobileDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports